'use client';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const chartData = [
  { day: '15 May', received: 9200, fraud: 1100 },
  { day: '16 May', received: 8950, fraud: 980 },
  { day: '17 May', received: 10300, fraud: 1430 },
  { day: '18 May', received: 9900, fraud: 1250 },
  { day: '19 May', received: 11100, fraud: 1510 },
  { day: '20 May', received: 10800, fraud: 1320 },
  { day: '21 May', received: 9700, fraud: 1180 },
  { day: '22 May', received: 12200, fraud: 1660 },
  { day: '23 May', received: 11900, fraud: 1495 },
  { day: '24 May', received: 10100, fraud: 1205 },
  { day: '25 May', received: 9300, fraud: 1002 },
  { day: '26 May', received: 10750, fraud: 1388 },
  { day: '27 May', received: 11600, fraud: 1540 },
  { day: '28 May', received: 12350, fraud: 1701 },
  { day: '29 May', received: 12890, fraud: 1812 },
];

export default function Home() {
  return (
    <main className="min-h-screen bg-slate-100">
      {/* Header */}

      <div className="bg-slate-950 text-white px-8 py-5 shadow">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">
            TelClick Reporting Portal
          </h1>

          <div className="text-sm text-slate-300">
            Fraud Monitoring Dashboard
          </div>
        </div>
      </div>

      <div className="p-8">

        {/* Filters */}

        <div className="bg-white rounded-2xl shadow p-6 mb-8">

          <h2 className="text-lg font-semibold mb-4">
            Filters
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">

            <select className="border rounded-lg p-3">
              <option>Ghana</option>
              <option>Uganda</option>
              <option>Rwanda</option>
              <option>Gambia</option>
              <option>Chad</option>
            </select>

            <select className="border rounded-lg p-3">
              <option>All Operators</option>
            </select>

            <select className="border rounded-lg p-3">
              <option>Authorized Gateways</option>
            </select>

            <input
              type="date"
              className="border rounded-lg p-3"
            />

            <input
              type="date"
              className="border rounded-lg p-3"
            />
          </div>
        </div>

        {/* KPI Cards */}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">

          <div className="bg-white rounded-2xl shadow p-6">
            <div className="text-slate-500 text-sm">
              Sent Calls Today
            </div>

            <div className="text-4xl font-bold mt-2">
              12,430
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow p-6">
            <div className="text-slate-500 text-sm">
              Received Calls Today
            </div>

            <div className="text-4xl font-bold mt-2 text-green-600">
              9,875
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow p-6">
            <div className="text-slate-500 text-sm">
              Fraud Calls Today
            </div>

            <div className="text-4xl font-bold mt-2 text-red-600">
              1,246
            </div>
          </div>

        </div>

        {/* Main Chart */}

        <div className="bg-white rounded-2xl shadow p-6">

          <h2 className="text-xl font-semibold mb-6">
            Received Calls vs Fraud Calls (Last 15 Days)
          </h2>

          <div style={{ width: '100%', height: '500px' }}>
            <ResponsiveContainer>

              <BarChart data={chartData}>

                <XAxis dataKey="day" />

                <YAxis />

                <Tooltip />

                <Legend />

                <Bar
                  dataKey="received"
                  name="Received Calls"
                />

                <Bar
                  dataKey="fraud"
                  name="Fraud Calls"
                />

              </BarChart>

            </ResponsiveContainer>
          </div>

        </div>

      </div>

    </main>
  );
}
